import React from "react";
import { FiCalendar, FiClock, FiRepeat, FiInfo } from "react-icons/fi";

const ScheduleSection = ({
  openDropdown,
  toggleDropdown,
  scheduleOption,
  handleOptionChange,
  formData,
  errors,
  handleChange,
  enableRecurrence,
  setEnableRecurrence,
  recurrencePattern,
  setRecurrencePattern,
  weeklyDays,
  setWeeklyDays,
  monthlyOption,
  setMonthlyOption,
  monthlyDay,
  setMonthlyDay,
  yearlyOption,
  setYearlyOption,
  recurrenceEndOption,
  setRecurrenceEndOption,
  recurrenceEndAfter,
  setRecurrenceEndAfter,
  recurrenceEndBy,
  setRecurrenceEndBy,
  recurrenceRule,
  setRecurrenceRule,
}) => {
  const daysOfWeek = [
    { id: 0, short: "Sun", long: "Sunday" },
    { id: 1, short: "Mon", long: "Monday" },
    { id: 2, short: "Tue", long: "Tuesday" },
    { id: 3, short: "Wed", long: "Wednesday" },
    { id: 4, short: "Thu", long: "Thursday" },
    { id: 5, short: "Fri", long: "Friday" },
    { id: 6, short: "Sat", long: "Saturday" },
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const weekOptions = [
    { value: "first", label: "First" },
    { value: "second", label: "Second" },
    { value: "third", label: "Third" },
    { value: "fourth", label: "Fourth" },
    { value: "last", label: "Last" },
  ];

  const toggleDaySelection = (dayId) => {
    if (weeklyDays.includes(dayId)) {
      setWeeklyDays(weeklyDays.filter((id) => id !== dayId));
    } else {
      setWeeklyDays([...weeklyDays, dayId].sort());
    }
  };

  const getMinScheduleDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // today
  };

  const getMinTime = () => {
    if (formData.scheduleDate === new Date().toISOString().split("T")[0]) {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = (now.getMinutes() + 1).toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }
    return "00:00";
  };

  return (
    <div className="card mb-4 border-0 shadow-sm">
      <div
        className="card-header bg-white d-flex justify-content-between align-items-center py-3"
        onClick={toggleDropdown}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
          <div
            className="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{
              width: "32px",
              height: "32px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            4
          </div>
          <div>
            <h5 className="mb-0">Schedule Your Message</h5>
            <small className="text-muted">
              {scheduleOption === "immediately"
                ? "Send immediately"
                : formData.scheduleDate
                ? `Scheduled for ${new Date(
                    formData.scheduleDate
                  ).toLocaleDateString()} at ${formData.scheduleTime}`
                : "Set delivery time"}
              {enableRecurrence && " (Recurring)"}
            </small>
          </div>
        </div>
        <span className="text-muted fs-5">{openDropdown ? "▲" : "▼"}</span>
      </div>

      {openDropdown && (
        <div className="card-body pt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="mb-4">
                <h6 className="fw-semibold mb-3 d-flex align-items-center">
                  <FiClock className="me-2 text-primary" />
                  Start Sending
                </h6>

                <div className="d-flex gap-4 mb-4">
                  <div className="form-check card-radio-option">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="immediately"
                      name="scheduleOption"
                      value="immediately"
                      checked={scheduleOption === "immediately"}
                      onChange={() => handleOptionChange("immediately")}
                    />
                    <label
                      className="form-check-label card-option"
                      htmlFor="immediately"
                    >
                      <div className="card-option-content">
                        <div className="fw-medium">Immediately</div>
                        <small className="text-muted">Send right away</small>
                      </div>
                    </label>
                  </div>

                  <div className="form-check card-radio-option">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="customDate"
                      name="scheduleOption"
                      value="customDate"
                      checked={scheduleOption === "customDate"}
                      onChange={() => handleOptionChange("customDate")}
                    />
                    <label
                      className="form-check-label card-option"
                      htmlFor="customDate"
                    >
                      <div className="card-option-content">
                        <div className="fw-medium">Custom Date</div>
                        <small className="text-muted">Schedule for later</small>
                      </div>
                    </label>
                  </div>
                </div>

                {scheduleOption === "customDate" && (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="scheduleDate"
                        className="form-label d-flex align-items-center"
                      >
                        <FiCalendar className="me-2 text-muted" />
                        Schedule Date
                      </label>
                      <input
                        type="date"
                        className={`form-control ${
                          errors.scheduleDate ? "is-invalid" : ""
                        }`}
                        id="scheduleDate"
                        name="scheduleDate"
                        value={formData.scheduleDate}
                        onChange={handleChange}
                        min={getMinScheduleDate()}
                      />
                      {errors.scheduleDate && (
                        <div className="invalid-feedback">
                          {errors.scheduleDate}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="scheduleTime" className="form-label">
                        Schedule Time
                      </label>
                      <input
                        type="time"
                        className={`form-control ${
                          errors.scheduleTime ? "is-invalid" : ""
                        }`}
                        id="scheduleTime"
                        name="scheduleTime"
                        value={formData.scheduleTime}
                        onChange={handleChange}
                        min={getMinTime()}
                      />
                      {errors.scheduleTime && (
                        <div className="invalid-feedback">
                          {errors.scheduleTime}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="form-check form-switch mb-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableRecurrence"
                    checked={enableRecurrence}
                    onChange={(e) => setEnableRecurrence(e.target.checked)}
                    disabled={scheduleOption === "immediately"}
                  />
                  <label
                    className="form-check-label d-flex align-items-center"
                    htmlFor="enableRecurrence"
                  >
                    <FiRepeat className="me-2 text-muted" />
                    <span className="fw-medium">Repeat this message</span>
                  </label>
                </div>

                {enableRecurrence && scheduleOption !== "immediately" && (
                  <div className="card p-4 mb-3 border-0 bg-light">
                    <h6 className="fw-semibold mb-3 d-flex align-items-center">
                      <FiRepeat className="me-2 text-primary" />
                      Recurrence Pattern
                    </h6>
                    <div className="mb-4">
                      <label className="form-label">Repeat every</label>
                      <select
                        className="form-select"
                        value={recurrencePattern}
                        onChange={(e) => setRecurrencePattern(e.target.value)}
                      >
                        <option value="daily">Day</option>
                        <option value="weekly">Week</option>
                        <option value="monthly">Month</option>
                        <option value="yearly">Year</option>
                      </select>
                    </div>
                    {recurrencePattern === "weekly" && (
                      <div className="mb-4">
                        <label className="form-label">Repeat on</label>
                        <div className="d-flex flex-wrap gap-2">
                          {daysOfWeek.map((day) => (
                            <button
                              key={day.id}
                              type="button"
                              className={`btn btn-sm ${
                                weeklyDays.includes(day.id)
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => toggleDaySelection(day.id)}
                              style={{ minWidth: "60px" }}
                            >
                              {day.short}
                            </button>
                          ))}
                        </div>
                        {weeklyDays.length === 0 && (
                          <small className="text-danger mt-2">
                            Select at least one day
                          </small>
                        )}
                      </div>
                    )}
                    {recurrencePattern === "monthly" && (
                      <div className="mb-4">
                        <label className="form-label mb-3">Repeat by</label>
                        <div className="d-flex gap-4 mb-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="monthlyOption"
                              id="dayOfMonth"
                              value="dayOfMonth"
                              checked={monthlyOption === "dayOfMonth"}
                              onChange={() => setMonthlyOption("dayOfMonth")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="dayOfMonth"
                            >
                              Specific day of month
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="monthlyOption"
                              id="dayOfWeek"
                              value="dayOfWeek"
                              checked={monthlyOption === "dayOfWeek"}
                              onChange={() => setMonthlyOption("dayOfWeek")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="dayOfWeek"
                            >
                              Day of week
                            </label>
                          </div>
                        </div>

                        {monthlyOption === "dayOfMonth" && (
                          <div
                            className="input-group"
                            style={{ maxWidth: "200px" }}
                          >
                            <span className="input-group-text">Day</span>
                            <input
                              type="number"
                              className="form-control"
                              min="1"
                              max="31"
                              value={monthlyDay}
                              onChange={(e) =>
                                setMonthlyDay(
                                  Math.min(31, Math.max(1, e.target.value))
                                )
                              }
                            />
                          </div>
                        )}

                        {monthlyOption === "dayOfWeek" && (
                          <div>
                            <div className="row g-2">
                              <div className="col-md-6">
                                <select className="form-select">
                                  {weekOptions.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-md-6">
                                <select className="form-select">
                                  {daysOfWeek.map((day) => (
                                    <option key={day.id} value={day.id}>
                                      {day.long}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <small className="text-muted mt-2">
                              Example: First Monday of the month
                            </small>
                          </div>
                        )}
                      </div>
                    )}
                    <h6 className="fw-semibold mb-3 mt-4">End Date</h6>
                    <div className="d-flex flex-column gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="recurrenceEnd"
                          id="noEnd"
                          value="noEnd"
                          checked={recurrenceEndOption === "noEnd"}
                          onChange={() => setRecurrenceEndOption("noEnd")}
                        />
                        <label className="form-check-label" htmlFor="noEnd">
                          Never (repeat indefinitely)
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="recurrenceEnd"
                          id="endAfter"
                          value="endAfter"
                          checked={recurrenceEndOption === "endAfter"}
                          onChange={() => setRecurrenceEndOption("endAfter")}
                        />
                        <label className="form-check-label" htmlFor="endAfter">
                          After a number of occurrences
                        </label>
                        {recurrenceEndOption === "endAfter" && (
                          <div
                            className="input-group mt-2"
                            style={{ maxWidth: "200px" }}
                          >
                            <input
                              type="number"
                              className="form-control"
                              min="1"
                              value={recurrenceEndAfter}
                              onChange={(e) =>
                                setRecurrenceEndAfter(e.target.value)
                              }
                            />
                            <span className="input-group-text">times</span>
                          </div>
                        )}
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="recurrenceEnd"
                          id="endBy"
                          value="endBy"
                          checked={recurrenceEndOption === "endBy"}
                          onChange={() => setRecurrenceEndOption("endBy")}
                        />
                        <label className="form-check-label" htmlFor="endBy">
                          On a specific date
                        </label>
                        {recurrenceEndOption === "endBy" && (
                          <div
                            className="input-group mt-2"
                            style={{ maxWidth: "250px" }}
                          >
                            <input
                              type="date"
                              className="form-control"
                              value={recurrenceEndBy}
                              onChange={(e) =>
                                setRecurrenceEndBy(e.target.value)
                              }
                              min={
                                formData.scheduleDate || getMinScheduleDate()
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* Insert after recurrence pattern UI, inside the same
                    enabled recurrence block */}
                    <div className="card p-3 mb-3 border-0">
                      <h6 className="fw-semibold mb-2 d-flex align-items-center">
                        <FiRepeat className="me-2 text-primary" />
                        Recurrence Rules
                      </h6>

                      <p className="small text-muted mb-2">
                        Choose which contacts should be included on every
                        repeat.
                      </p>

                      <div className="mb-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="recurrenceRule"
                            id="ruleAll"
                            value="all"
                            checked={recurrenceRule === "all"}
                            onChange={() => setRecurrenceRule("all")}
                          />
                          <label className="form-check-label" htmlFor="ruleAll">
                            Send to <strong>All contacts</strong>
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="recurrenceRule"
                            id="ruleOnlyClicked"
                            value="onlyClicked"
                            checked={recurrenceRule === "onlyClicked"}
                            onChange={() => setRecurrenceRule("onlyClicked")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="ruleOnlyClicked"
                          >
                            Send to <strong>Only clicked</strong> contacts
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="recurrenceRule"
                            id="ruleExceptClicked"
                            value="exceptClicked"
                            checked={recurrenceRule === "exceptClicked"}
                            onChange={() => setRecurrenceRule("exceptClicked")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="ruleExceptClicked"
                          >
                            Send to <strong>All except clicked</strong> contacts
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="recurrenceRule"
                            id="ruleOnlyDelivered"
                            value="onlyDelivered"
                            checked={recurrenceRule === "onlyDelivered"}
                            onChange={() => setRecurrenceRule("onlyDelivered")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="ruleOnlyDelivered"
                          >
                            Send to <strong>Only delivered</strong> contacts
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="recurrenceRule"
                            id="ruleOnlyFailed"
                            value="onlyFailed"
                            checked={recurrenceRule === "onlyFailed"}
                            onChange={() => setRecurrenceRule("onlyFailed")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="ruleOnlyFailed"
                          >
                            Send to <strong>Only failed</strong> contacts
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card border-0 bg-light p-3">
                <h6 className="fw-semibold d-flex align-items-center mb-3">
                  <FiInfo className="me-2 text-primary" />
                  Scheduling Tips
                </h6>
                <ul className="list-unstyled small text-muted mb-0">
                  <li className="mb-2">
                    • Schedule during business hours for better engagement
                  </li>
                  <li className="mb-2">
                    • Consider time zones of your recipients
                  </li>
                  <li className="mb-2">
                    • Test time-sensitive messages in advance
                  </li>
                  <li className="mb-2">
                    • Recurring messages work best for reminders and updates
                  </li>
                  <li>• Avoid sending messages too early or too late</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScheduleSection;
